<template>
  <button class="btn toggle-filter-button" @click="$emit('click')">
    <svg class="icon" width="16px" height="16px" viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <title>icon-filter</title>
      <g id="TransCon-Direction" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="SuperC---Mobile---4-Column---FR" fill="currentColor" transform="translate(-341.000000, -138.000000)" fill-rule="nonzero">
          <path d="M356.927045,138.443182 C357.055646,138.753788 357.002693,139.018939 356.768184,139.238636 L351.174023,144.840909 L351.174023,153.272727 C351.174023,153.590909 351.02651,153.814394 350.731483,153.943182 C350.633141,153.981061 350.538581,154 350.447804,154 C350.243554,154 350.073347,153.92803 349.93718,153.784091 L347.032302,150.875 C346.888571,150.731061 346.816705,150.560606 346.816705,150.363636 L346.816705,144.840909 L341.222544,139.238636 C340.988036,139.018939 340.935082,138.753788 341.063684,138.443182 C341.192285,138.147727 341.415446,138 341.733167,138 L356.257561,138 C356.575282,138 356.798443,138.147727 356.927045,138.443182 Z" id="icon-filter" transform="translate(348.995364, 146.000000) scale(-1, 1) translate(-348.995364, -146.000000) "></path>
        </g>
      </g>
    </svg>
  </button>
</template>

<script>
export default {
  name: "ToggleFilterButton"
}
</script>

<style lang="scss">
  .toggle-filter-button.btn {

    .icon {
      color: #545454;
    }
    &.active {
      &:hover {
        background-color: var(--primary-color);
      }
      background-color: var(--primary-color);
      .icon{
        color: var(--primary-text-color)
      }
    }
  }
</style>
